function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m5 47h-2v4h29 29v-4h-2z",
  fill: "#9bc9ff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m3 7h2 54 2v-4h-58z",
  fill: "#9bc9ff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m37.04 16.88-5.04-5.88-5.04 5.88a3.976 3.976 0 0 0 -.96 2.6v5.52l-6 10h10v4l2 4 2-4v-4h10l-6-10v-5.52a3.976 3.976 0 0 0 -.96-2.6zm-5.04 9.12a2 2 0 1 1 2-2 2.006 2.006 0 0 1 -2 2z",
  fill: "#9bc9ff"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 59,
  fill: "#9bc9ff",
  r: 2
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#57a4ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m61 8a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-58a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1v38h-1a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h28v4.184a3 3 0 1 0 2 0v-4.184h28a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-1v-38zm-29 52a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm-28-56h56v2h-56zm56 46h-56v-2h56zm-2-4h-52v-38h52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32 27a3 3 0 1 0 -3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1 1 0 0 1 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.13 35.493a1 1 0 0 0 .87.507h5v2a1.006 1.006 0 0 0 .168.555l2 3a1 1 0 0 0 1.664 0l.758-1.138 1.515 3.03a1 1 0 0 0 1.79 0l1.515-3.03.758 1.138a1 1 0 0 0 1.664 0l2-3a1.006 1.006 0 0 0 .168-.555v-2h5a1 1 0 0 0 .857-1.515l-5.857-9.762v-5.244a5.006 5.006 0 0 0 -1.2-3.253l-5.037-5.877a1.033 1.033 0 0 0 -1.518 0l-5.045 5.877a5.011 5.011 0 0 0 -1.2 3.253v5.244l-5.857 9.762a1 1 0 0 0 -.013 1.008zm8.87 3.707-1-1.5v-1.7h2v1.7zm4 1.567-1-2v-2.767h2v2.764zm4-1.567-1-1.5v-1.7h2v1.7zm6.233-5.2h-3.233v-5.389zm-15.233-14.521a3.007 3.007 0 0 1 .722-1.952l4.278-4.99 4.277 4.99a3 3 0 0 1 .723 1.952v14.521h-4v-3h-2v3h-4zm-2 9.132v5.389h-3.233z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 14h3v-2h-4a1 1 0 0 0 -1 1v4h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 42h4v-2h-3v-3h-2v4a1 1 0 0 0 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48 17h2v-4a1 1 0 0 0 -1-1h-4v2h3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48 40h-3v2h4a1 1 0 0 0 1-1v-4h-2z"
}));

var SvgMurtskuLogoBoardBlue = function SvgMurtskuLogoBoardBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMurtskuLogoBoardBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/murtsku-logo-board-blue.c0ea8442.svg";
export { ForwardRef as ReactComponent };